/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, June 2020
 */

import React from 'react';
import { connect } from 'react-redux';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import GrayPanel from '../GrayPanel/GrayPanel';

const content = {
  hrubieszow:
  <div>
    <p>
      Gmina Miejska Hrubieszów jako Administrator danych osobowych będzie przetwarzać Państwa dane osobowe w celu realizacji niniejszego wniosku na podstawie art. 6 ust. 1 lit. c, e i a RODO.
    </p>
    <p>
      Przysługuje Państwu prawo dostępu do swoich danych oraz otrzymywania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do ograniczenia przetwarzania danych, prawo wniesienia skargi do organu nadzorczego, którym jest Prezes Urzędu Ochrony Danych Osobowych.
    </p>
    <p>
      Pełna treść klauzuli informacyjnej dostępna jest w Urzędzie Miasta Hrubieszów  oraz na stronie umhrubieszow.bip.lubelskie.pl – Ochrona danych osobowych.
    </p>
  </div>,
};

class RodoContent extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  render() {
    return (
      this.props.prefix in content ?
        <GrayPanel title={'Klauzula informacyjna'}>
          <div className="row">
            <div className="col-sm-12">
              {content[this.props.prefix]}
            </div>
          </div>
        </GrayPanel>
      : null
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default connect(mapState)(RodoContent);




// WEBPACK FOOTER //
// src/components/RodoContent/RodoContent.js